import { ColumnType } from "antd/es/table";
import styles from "./plateItem.module.css";
import { ReactNode } from "react";
import { DefaultCheckbox } from "ui";
import { CheckboxProps, Tooltip } from "antd";
import { PlateItemHeader } from "./PlateItemHeader";

interface PlateItemProps<T> {
  item: T;
  indexN?: number | null;
  columns: Array<ColumnType<T>>;
  headerItemComponent?: ReactNode | ((item: T) => ReactNode);
  footerItemComponent?: ReactNode | ((item: T) => ReactNode);
  checkbox?: {
    getCheckboxProps?: (item: T) => CheckboxProps & { tooltip?: string };
  };
}

export const PlateItem = <T,>({
  item,
  columns,
  headerItemComponent,
  footerItemComponent,
  checkbox,
}: PlateItemProps<T>) => {
  const renderCellContent = (column: ColumnType<T>, index: number) => {
    const value = (item as any)[column.dataIndex!];
    return column.render ? column.render(value, item, 0) : value;
  };

  const headerContent =
    typeof headerItemComponent === "function" ? (
      <PlateItemHeader
        headerContent={headerItemComponent(item)}
        checkbox={checkbox ? { checkboxProps: checkbox.getCheckboxProps?.(item) } : undefined}
      />
    ) : (
      headerItemComponent
    );

  const footerContent = typeof footerItemComponent === "function" ? footerItemComponent(item) : footerItemComponent;

  return (
    <div className={`${styles.plateItem}`}>
      {headerContent && headerContent}

      <div className={styles.plateContent}>
        {columns.map((column, index) => (
          <div key={column.key || index} className={`${styles.columnSection} ${column.className || ""}`}>
            {renderCellContent(column, index)}
          </div>
        ))}
      </div>

      {footerContent && footerContent}
    </div>
  );
};
